import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography } from '@mui/material';

import { useModo } from '../config/modo';
import CabeceraSeccion from '../components/CabeceraSeccion';
import './fundacion.css';
import './comoleer.css';

/**
 * TIPS & HINTS — enseñar a recibir una canalización.
 *
 * Faina, 11-sep: «quiero agregar una página al menú… redactar cómo nos gustaría
 * que leyera las canalizaciones, cómo escuchara la música, nuestras sugerencias
 * en base a lo que creemos que es mejor para el oyente».
 *
 * Es el complemento exacto de «Cómo trabajamos» (La Fundación): aquella dice
 * cómo NACE una canalización; esta, cómo se RECIBE. Se llama «Cómo leer»
 * para que entre en la familia de «Cómo trabajamos». Faina la tuvo unas horas
 * como «Tips & Hints» (postura de sugerencia, no de instrucción) y la volvió
 * al español el mismo día: era la única entrada del menú en inglés y el sitio
 * se traduce a decenas de idiomas; el tono de sugerencia lo ponen los textos.
 * La ruta es `/como-leer`.
 *
 * 🔴 NADA AQUÍ ES INVENTADO: cada sugerencia es una definición de la Fundación
 * dicha al lector —un mensaje al día (Def 78) · los párrafos como pasos (la
 * vara) · respirar antes (el umbral de la ficha) · la música antes, no debajo
 * (Def 72: «abre la puerta a la voz») · si duele, no cerrar (el lente HERIDA)
 * · el gesto, hecho una vez (el lente PRÁCTICA) · el nombre (Def 40) · sin
 * órdenes ni profecías (Def 65) · compartirlo (así crece el sitio)—.
 *
 * ✅ EL TEXTO ES DE FAINA (las diez, palabra por palabra). Vive en
 * `public/locales/<lng>/common.json` → `leer`; para cambiarlo se toca ahí y
 * esta página no.
 *
 * Se pinta con las tarjetas de «Cómo trabajamos» (`.fun-regla`) para que se
 * vea que son de la misma familia, con el título de cada una en negrita.
 */
/* 🟥 LAS DIEZ SON DE FAINA, palabra por palabra (11-sep): las nueve primeras
   las dicto una a una y la decima —«Sintiendote diferente»— la puso el con
   su voz sobre mi propuesta. Las siete de mi borrador inicial no le
   gustaron y se retiraron de los 33 idiomas: un huerfano revive en la
   siguiente pasada de traduccion. */
const SUGERENCIAS = ['s0', 's0b', 's0c', 's0d', 's1', 's1b', 's9', 's8', 's11', 's12'];

const ComoLeerPage = () => {
  const { t } = useTranslation();
  const { modo } = useModo();

  return (
    <Box className={`fun fun-${modo} leer`}>
      {/* La misma cabecera que La Fundación y las secciones de voces, solo el
          titulo: Faina saco la bajada («Una canalización no se lee como una
          noticia…») el 11-sep —«FUERA»—; las diez hablan solas. Reusar el
          componente es lo que hace que esta pagina se vea de la misma familia
          sin repetir una linea de CSS. */}
      <CabeceraSeccion titulo={t('leer.titulo')} />

      <Container maxWidth="lg">
        <Box className="fun-reglas leer-lista">
          {SUGERENCIAS.map((s, i) => (
            <Box className="fun-regla leer-sugerencia" key={s}>
              <span className="leer-numero">{i + 1}</span>
              <Typography component="span" className="leer-titulo">{t(`leer.${s}_t`)}</Typography>
              <Typography component="p" className="leer-texto">{t(`leer.${s}`)}</Typography>
            </Box>
          ))}
        </Box>

        {/* EL CIERRE, EN NARANJA Y ENTRE COMILLAS (Faina, 20-sep: «agrega al
            final, en naranjo, comillas, "Convencido de que debemos avanzar a un
            nuevo entendimiento"»). Ya hubo uno el 13-sep («CON EL CORAZÓN
            ABIERTO»), que pasó a ser la tarjeta 8; este es otro. Las comillas
            las pone el código, no el texto: así en cada idioma salen las suyas. */}
        <Typography className="leer-cierre">«{t('leer.cierre')}»</Typography>
      </Container>
    </Box>
  );
};

export default ComoLeerPage;
